/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Modal} from 'react-bootstrap'
import {createPortal} from 'react-dom'
import {KTSVG} from '../../../template/helpers'

type Props = {
  recordUrl: string
  show: boolean
  handleClose: () => void
}

const modalsRoot = document.getElementById('root-modals') || document.body
const CDRModalRecord: FC<Props> = ({recordUrl, show, handleClose}) => {
  return createPortal(
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title>Запись разговора</Modal.Title>
        <span className='cursor-pointer' onClick={handleClose}>
          <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className='d-flex justify-content-center'>
          <audio controls>
            <source src={recordUrl} type='audio/mpeg' />
            Your browser does not support the audio element.
          </audio>
        </div>
      </Modal.Body>
    </Modal>,
    modalsRoot
  )
}

export {CDRModalRecord}
